export default {
    name: "NoResults"
}